import { Dimension } from '../types';

export const getDimensionName = (dimension: Dimension) => {
  switch (dimension) {
    case Dimension.campagin:
      return 'Campaign';
    case Dimension.media:
      return 'Media';
    case Dimension.campaignGroup:
      return 'Campaign Group';
  }
};
